import {EntityUnfollowedEvent} from './EntityUnfollowedEvent';

export class TeamUnfollowed extends EntityUnfollowedEvent {}
